import { baseApi, API_TAGS } from '@/shared/api';
import { createDashboardEndpointBuilder, type DashboardLocationsResponse } from '@/entities/dashboard';

const locationsEndpoint = createDashboardEndpointBuilder('/locations');

export const locationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardLocations: builder.query<DashboardLocationsResponse, { projectId?: string | number }>({
      query: ({ projectId }) => ({
        url: locationsEndpoint(''),
        params: { projectId }
      }),
      providesTags: (_result, _error, { projectId }) => [
        API_TAGS.DASHBOARD,
        { type: API_TAGS.LOCATIONS, id: projectId }
      ]
    })
  })
});

export const { useGetDashboardLocationsQuery } = locationsApi;
